import { combineReducers } from 'redux';
// features
import router from './router/reducer';
import auth from './features/auth/reducer';
import board from './features/board/reducer';
import modal from './components/modal/reducer';
import loader from './features/loader/reducer';
import header from './components/app-layout/header/reducer';
import report from './components/report-format-panel/reducer';
//////////////////////////////////////////////////

const appReducer = combineReducers({
  auth,
  board,
  modal,
  loader,
  header,
  router,
  report,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
